import React from 'react'
import PropTypes from 'prop-types'
import { makeT } from '../../group_leader/helpers/i18n'
import { formatClockTime } from '../helpers/results'

const t = makeT('group_leader.event_results.live_bar')

// While live: says the page is polling, when it last heard back, and offers a refresh.
const LiveBar = ({ isFetching, lastUpdatedAt, hourFormat, onRefresh }) => (
  <div className="gl-event-results-live-bar">
    <span className="gl-event-results-live-dot-sm" aria-hidden="true"/>
    <span className="gl-event-results-live-bar-text">{t('text')}</span>
    {isFetching
      ? (
        <span
          className="gl-event-results-fetch-spinner"
          role="status"
          aria-label={t('fetching_aria')}
          />
      )
      : lastUpdatedAt && (
        <span className="gl-event-results-live-bar-time">
          {t('updated', { time: formatClockTime(lastUpdatedAt, hourFormat) })}
        </span>
      )
    }
    <button
      className="gl-event-results-live-bar-refresh"
      type="button"
      onClick={onRefresh}
      disabled={isFetching}
      aria-label={t('refresh_aria')}
      >
      {t('refresh')}
    </button>
  </div>
)

LiveBar.propTypes = {
  isFetching: PropTypes.bool,
  lastUpdatedAt: PropTypes.instanceOf(Date),
  // The account's hour setting: 'am_pm' or '24h'
  hourFormat: PropTypes.string,
  onRefresh: PropTypes.func.isRequired,
}

export default LiveBar
